// Client-side filters of the collaborators list (#602). The rules are also
// explained to the user in the grid's footer note (collaborators.filters.help).

// "Todas as lojas" option of the store filter (stands in for an access filter).
export const ALL_STORES = 'all';

export const EMPTY_FILTERS = { store: '', status: '', role: '', search: '' };

// The status shown to the user: an invited collaborator whose set-password
// link has expired (auth_service's deadline, kept in invitation.expires_at)
// shows as "expired" — a UI-only status, the API keeps "invited".
export const displayStatus = (collaborator) =>
  collaborator.status === 'invited' && collaborator.invitation?.is_expired ? 'expired' : collaborator.status;

// The roles a collaborator holds: the all-stores role, or the one in `store`
// (any store when none is picked) for specific-stores access.
const rolesOf = (collaborator, store) => {
  if (collaborator.business_scope === 'all') return [collaborator.global_role?.uuid];
  return collaborator.memberships
    .filter((m) => store === '' || m.business.uuid === store)
    .map((m) => m.role.uuid);
};

// Removed collaborators only show up when that status is picked explicitly.
// A store matches everyone with access to it: all-stores access or a
// membership in that store; ALL_STORES matches only all-stores access. With a
// store picked, the role filter checks the role held in that store.
export const matchesFilters = (collaborator, { status, store, role, search }) => {
  if (status === '' ? collaborator.status === 'removed' : displayStatus(collaborator) !== status) return false;
  if (store === ALL_STORES && collaborator.business_scope !== 'all') return false;
  if (
    store !== '' &&
    store !== ALL_STORES &&
    collaborator.business_scope !== 'all' &&
    !collaborator.memberships.some((m) => m.business.uuid === store)
  ) {
    return false;
  }
  if (role !== '' && !rolesOf(collaborator, store === ALL_STORES ? '' : store).includes(role)) return false;
  if (search) {
    const term = search.toLowerCase();
    if (!collaborator.name.toLowerCase().includes(term) && !collaborator.email.toLowerCase().includes(term)) {
      return false;
    }
  }
  return true;
};
